export function safeParseJson(value) {
    if (value) {
        try {
            const content = value.trim();
            return (content !== "")
                ? JSON.parse(content)
                : null;
        }
        catch (e) {
            console.error(`Could not parse JSON content: ${e.message}`, e);
        }
    }
    return null;
}
export function parseElementAsJson(element) {
    return null !== element
        ? safeParseJson((element.textContent || "")
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">")
            .replace(/&amp;/g, "&"))
        : null;
}
